import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'digital-platform-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class NavHeaderComponent {
  @Input() mobileHeaderTitle: string | null = null;
  @Input() mobileNavOpen = false;
  @Input() onBackClick: (() => void) | null = null;
}
